import OapVideoImmersive from './code/Scripts/components/oap-video-immersive.vue';

export default {
  components: {
    OapVideoImmersive,
  },
};
